import { i18n } from '@selfserve/react-utils';

import { Property } from '../types';

export const STATUS_VALUE = 'Status';

export const partnerProperties: Property[] = [
  { text: i18n.t('common.account-name'), value: 'Name', mandatory: true },
  { text: i18n.t('common.usage'), value: 'score', mandatory: true },
  { text: i18n.t('common.partner-id'), value: 'pid', sortingValue: 'id', mandatory: true },
  {
    text: i18n.t('common.created-at'),
    value: 'Created at',
    sortingValue: 'created_at',
    defaultChecked: true,
  },
  // { text: i18n.t('common.plan'), value: 'plan' },
  { text: i18n.t('common.status'), value: STATUS_VALUE, sortingValue: 'status', defaultChecked: true },
  {
    text: i18n.t('common.total-entries'),
    value: 'total entries',
    defaultChecked: true,
  },
  {
    text: i18n.t('common.peak-storage'),
    value: 'peak storage',
    defaultChecked: true,
  },
  { text: i18n.t('common.events'), value: 'Events', defaultChecked: true },
  { text: i18n.t('common.admins'), value: 'Admins', defaultChecked: true },
  {
    text: i18n.t('common.total-jobs-completed'),
    value: 'total jobs completed',
  },
  { text: i18n.t('common.total-credits'), value: 'total credits' },
  {
    text: i18n.t('common.total-video-entries'),
    value: 'total interactive video entries',
  },
  { text: i18n.t('common.attended'), value: 'attended' },
  { text: i18n.t('common.average-storage'), value: 'average storage' },
  {
    text: i18n.t('common.bandwidth-consumption'),
    value: 'bandwidth consumption',
  },
  { text: i18n.t('common.blocked'), value: 'blocked' },
  { text: i18n.t('common.confirmed'), value: 'confirmed' },
  { text: i18n.t('common.created'), value: 'created' },
  { text: i18n.t('common.invited'), value: 'invited' },
  { text: i18n.t('common.live-view-time'), value: 'live view time' },
  { text: i18n.t('common.participated'), value: 'participated' },
  { text: i18n.t('common.registered'), value: 'registered' },
  {
    text: i18n.t('common.transcoding-consumption'),
    value: 'transcoding consumption',
  },
  {
    text: i18n.t('common.transcoding-duration'),
    value: 'transcoding duration',
  },
  { text: i18n.t('common.unique-known-users'), value: 'unique known users' },
  { text: i18n.t('common.unregistered'), value: 'unregistered' },
  { text: i18n.t('common.video-streams'), value: 'video streams' },
];

export const defaultPartnerProperies = partnerProperties.filter(
  ({ mandatory, defaultChecked }) => mandatory || defaultChecked
);
